var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-contents"},_vm._l((_vm.blocks),function(block,key){return _c(_vm.component(block.type),{key:key,tag:"component",attrs:{"data":block.data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }